/* ============================================================
   GRENADINE — Mots fléchés (page Jeux, vue #mots-fleches)
   Grilles générées et validées hors ligne (gen.js + test.js).
   Réponses stockées en MAJUSCULES sans accents.
   ============================================================ */
(function(){
  'use strict';
  var LEVELS = {"debutant":{"w":8,"h":11,"words":[{"a":"ONDULE","q":"Entre lisse et bouclé","r":1,"c":2,"d":"a"},{"a":"NANA","q":"Elle vous diagnostique en ligne","r":1,"c":3,"d":"d"},{"a":"LYON","q":"Ville du salon","r":1,"c":6,"d":"d"},{"a":"BAC","q":"On y passe la tête au salon","r":4,"c":2,"d":"a"},{"a":"CREPU","q":"La plus serrée des textures","r":4,"c":4,"d":"d"},{"a":"MECHE","q":"Petite partie de la chevelure","r":6,"c":3,"d":"a"},{"a":"SERUM","q":"Concentré en compte-gouttes","r":8,"c":1,"d":"a"},{"a":"PEIGNE","q":"Il a des dents mais ne mord pas","r":5,"c":7,"d":"d"},{"a":"COUPE","q":"Affaire de ciseaux","r":10,"c":3,"d":"a"},{"a":"LISSE","q":"Texture sans un pli","r":6,"c":1,"d":"d"}]},"moyen":{"w":11,"h":13,"words":[{"a":"ADHERENTE","q":"Membre de GRENADINE PLUS","r":3,"c":2,"d":"a"},{"a":"OLAPLEX","q":"Marque réparatrice vendue au salon","r":1,"c":2,"d":"d"},{"a":"MERCREDI","q":"Porte close au salon","r":1,"c":6,"d":"d"},{"a":"PEIGNE","q":"Il a des dents mais ne mord pas","r":6,"c":1,"d":"a"},{"a":"POINTES","q":"Elles fourchent parfois","r":8,"c":4,"d":"a"},{"a":"LISSAGE","q":"Brésilien, au salon","r":6,"c":10,"d":"d"},{"a":"RINCAGE","q":"Il suit le shampoing","r":12,"c":4,"d":"a"},{"a":"BONNET","q":"Il protège les cheveux la nuit","r":1,"c":8,"d":"d"},{"a":"BAC","q":"On y passe la tête au salon","r":1,"c":8,"d":"a"},{"a":"NANA","q":"Elle vous diagnostique en ligne","r":10,"c":7,"d":"a"},{"a":"SOIN","q":"Classique ou profond, au salon","r":1,"c":1,"d":"a"},{"a":"PAPER","q":"GRENADINE ___, le magazine du blog","r":8,"c":4,"d":"d"},{"a":"COUPE","q":"Affaire de ciseaux","r":10,"c":1,"d":"a"},{"a":"MECHE","q":"Petite partie de la chevelure","r":8,"c":1,"d":"d"}]},"expert":{"w":12,"h":17,"words":[{"a":"DIAGNOSTIC","q":"Nana vous le fait en ligne","r":15,"c":2,"d":"a"},{"a":"SHAMPOING","q":"Mousse au bac","r":7,"c":5,"d":"d"},{"a":"POINTES","q":"Elles fourchent sans couverts","r":13,"c":3,"d":"a"},{"a":"POROSITE","q":"Soif du cheveu","r":9,"c":9,"d":"d"},{"a":"SPIRALE","q":"Boucle qui tourne en rond","r":7,"c":5,"d":"a"},{"a":"MERCREDI","q":"Jour où les ciseaux se reposent","r":2,"c":11,"d":"d"},{"a":"PAPER","q":"Magazine en ligne qui se dit papier","r":11,"c":5,"d":"a"},{"a":"KERATINE","q":"Protéine qui fait le cheveu","r":2,"c":7,"d":"d"},{"a":"PEIGNE","q":"Il a des dents mais ne mord pas","r":3,"c":6,"d":"a"},{"a":"LISSAGE","q":"Brésilien qui ne parle pas portugais","r":9,"c":1,"d":"a"},{"a":"OLAPLEX","q":"Bâtisseur de liens vendu au salon","r":8,"c":1,"d":"d"},{"a":"BALMAIN","q":"Couturier qui coiffe aussi la boutique","r":5,"c":3,"d":"a"},{"a":"BROSSET","q":"Général du coin, à l'adresse du salon","r":5,"c":3,"d":"d"},{"a":"VEGAN","q":"Rien d'animal là-dedans","r":1,"c":9,"d":"d"},{"a":"BAC","q":"On s'y allonge sans l'avoir révisé","r":13,"c":11,"d":"d"},{"a":"NANA","q":"Elle vous pose les bonnes questions","r":2,"c":4,"d":"d"},{"a":"SOIN","q":"Profond, sans être philosophe","r":2,"c":1,"d":"a"},{"a":"SERUM","q":"Flacon qui se compte en gouttes","r":2,"c":1,"d":"d"}]}};
  var ORDER = ['debutant','moyen','expert'];
  var LABELS = {debutant:'Débutant', moyen:'Moyen', expert:'Expert'};
  var ARROW = {a:'→', d:'↓'};

  function norm(s){ return String(s).normalize('NFD').replace(/[̀-ͯ]/g,'').toUpperCase().replace(/[^A-Z]/g,''); }

  /* Construit la grille : cellules 'L' (lettre), 'C' (définition), 'E' (vide) */
  function build(lv){
    var w=lv.w, h=lv.h, cells=[], r, c;
    for(r=0;r<h;r++){ cells.push([]); for(c=0;c<w;c++) cells[r].push({t:'E'}); }
    var words = lv.words.map(function(x){
      var dr=x.d==='d'?1:0, dc=x.d==='a'?1:0;
      return {a:x.a, q:x.q, d:x.d, r:x.r, c:x.c, cr:x.r-dr, cc:x.c-dc,
        cells:x.a.split('').map(function(_,i){ return [x.r+dr*i, x.c+dc*i]; })};
    });
    words.sort(function(p,q){ return (p.cr*w+p.cc)-(q.cr*w+q.cc) || (p.d==='a'?-1:1); });
    words.forEach(function(wd,i){
      wd.n=i+1;
      var cl=cells[wd.cr][wd.cc];
      if(cl.t==='L') throw new Error('clue on letter '+wd.a);
      if(cl.t!=='C') cells[wd.cr][wd.cc]=cl={t:'C', clues:[]};
      cl.clues.push(i);
      wd.cells.forEach(function(p,k){
        var cell=cells[p[0]][p[1]];
        if(cell.t==='C') throw new Error('letter on clue '+wd.a);
        if(cell.t==='E') cells[p[0]][p[1]]=cell={t:'L', ans:wd.a[k], w:{}};
        if(cell.ans!==wd.a[k]) throw new Error('crossing mismatch '+wd.a+' at '+p);
        if(cell.w[wd.d]!==undefined) throw new Error('two words same dir on cell '+p);
        cell.w[wd.d]=i;
      });
    });
    return {w:w, h:h, cells:cells, words:words};
  }

  if(typeof module!=='undefined' && module.exports){ module.exports={LEVELS:LEVELS, build:build, norm:norm}; return; }

  var app=document.getElementById('mf-app'); if(!app) return;

  function store(k,v){ try{ if(v===undefined) return window.localStorage.getItem(k); if(v===null) window.localStorage.removeItem(k); else window.localStorage.setItem(k,v); }catch(e){ return null; } }

  try{ ['level','debutant','moyen','expert'].forEach(function(k){ window.localStorage.removeItem('gj-mf-v1-'+k); }); }catch(e){} /* anciennes grilles */
  var level = store('gj-mf-v2-level'); if(!LEVELS[level]) level='debutant';
  var G, letters, hints, cur=null, lastClueTap=null;

  app.innerHTML =
    '<div class="mf-levels" role="group" aria-label="Niveau">'+ORDER.map(function(k){return '<button type="button" class="mf-level" data-level="'+k+'">'+LABELS[k]+'</button>';}).join('')+'</div>'+
    '<div class="mf-clue" id="mf-clue" aria-live="polite"></div>'+
    '<div class="mf-board" id="mf-board"><div class="mf-grid" id="mf-grid"></div>'+
      '<input id="mf-input" class="mf-input" type="text" value=" " autocomplete="off" autocorrect="off" autocapitalize="characters" spellcheck="false" aria-label="Saisir une lettre"></div>'+
    '<div class="mf-done" id="mf-done">Bravo ! 🎉</div>'+
    '<div class="mf-status" id="mf-status"></div>'+
    '<div class="mf-actions"><button type="button" class="mf-btn mf-btn--dark" data-act="check">Vérifier</button><button type="button" class="mf-btn mf-btn--dark" data-act="hint">Indice</button><button type="button" class="mf-btn mf-btn--line" data-act="reset">Recommencer</button></div>'+
    '<div class="mf-list" id="mf-list"></div>';

  var gridEl=document.getElementById('mf-grid'), boardEl=document.getElementById('mf-board'), input=document.getElementById('mf-input'),
      clueEl=document.getElementById('mf-clue'), doneEl=document.getElementById('mf-done'), statusEl=document.getElementById('mf-status'), listEl=document.getElementById('mf-list');

  function key(){ return 'gj-mf-v2-'+level; }
  function save(){
    var s=''; for(var r=0;r<G.h;r++) for(var c=0;c<G.w;c++) s+=(letters[r][c]||'.');
    store(key(), JSON.stringify({l:s, h:Object.keys(hints)}));
  }
  function load(){
    letters=[]; hints={};
    for(var r=0;r<G.h;r++){ letters.push([]); for(var c=0;c<G.w;c++) letters[r].push(''); }
    var raw=store(key()); if(!raw) return;
    try{ var o=JSON.parse(raw), i=0;
      for(r=0;r<G.h;r++) for(c=0;c<G.w;c++,i++){ var ch=o.l.charAt(i); if(/[A-Z]/.test(ch) && G.cells[r][c].t==='L') letters[r][c]=ch; }
      (o.h||[]).forEach(function(k){ hints[k]=1; });
    }catch(e){}
  }

  function setLevel(k){
    level=k; store('gj-mf-v2-level',k);
    G=build(LEVELS[k]); load(); cur=null; lastClueTap=null;
    var btns=app.querySelectorAll('.mf-level');
    for(var i=0;i<btns.length;i++){ var on=btns[i].getAttribute('data-level')===k; btns[i].classList.toggle('is-on',on); btns[i].setAttribute('aria-pressed',on?'true':'false'); }
    gridEl.style.gridTemplateColumns='repeat('+G.w+',1fr)';
    boardEl.style.maxWidth=(G.w*46)+'px';
    /* ordinateur : la grille entiere tient dans la hauteur de l'ecran */
    if(window.innerWidth>=900){ var gh=(G.h||G.rows||(G.grid&&G.grid.length)||G.w); var fitW=Math.floor((window.innerHeight-150)*G.w/gh); boardEl.style.setProperty('max-width',Math.max(300,Math.min(520,fitW))+'px','important'); }
    var html='';
    for(var r=0;r<G.h;r++) for(var c=0;c<G.w;c++){
      var cell=G.cells[r][c];
      if(cell.t==='L') html+='<div class="mf-cell mf-cell--l" data-r="'+r+'" data-c="'+c+'"><span></span></div>';
      else if(cell.t==='C') html+='<div class="mf-cell mf-cell--c" data-r="'+r+'" data-c="'+c+'">'+cell.clues.map(function(i){var wd=G.words[i];return '<span class="mf-tag">'+wd.n+ARROW[wd.d]+'</span>';}).join('')+'</div>';
      else html+='<div class="mf-cell mf-cell--e"></div>';
    }
    gridEl.innerHTML=html;
    listEl.innerHTML=['a','d'].map(function(d){
      return '<div class="mf-col"><p class="mf-col-t">'+(d==='a'?'Horizontal →':'Vertical ↓')+'</p><ol>'+
        G.words.filter(function(wd){return wd.d===d;}).map(function(wd){var i=G.words.indexOf(wd);return '<li data-w="'+i+'"><b>'+wd.n+'</b> '+wd.q+' <em>('+wd.a.length+')</em></li>';}).join('')+'</ol></div>';
    }).join('');
    statusEl.textContent='';
    var first=G.words[0]; select(first.cells[0][0], first.cells[0][1], first.d, true);
    paint();
  }

  function cellEl(r,c){ return gridEl.querySelector('[data-r="'+r+'"][data-c="'+c+'"]'); }
  function curWord(){ if(!cur) return null; var i=G.cells[cur.r][cur.c].w[cur.d]; return i===undefined?null:G.words[i]; }

  function select(r,c,d,noFocus){
    var cell=G.cells[r][c]; if(cell.t!=='L') return;
    if(cell.w[d]===undefined) d=(d==='a'?'d':'a');
    cur={r:r,c:c,d:d};
    paint();
    if(!noFocus) focusInput();
  }
  function focusInput(){
    var el=cellEl(cur.r,cur.c);
    if(el){ input.style.top=el.offsetTop+'px'; input.style.left=el.offsetLeft+'px'; input.style.width=el.offsetWidth+'px'; input.style.height=el.offsetHeight+'px'; }
    try{ input.focus({preventScroll:true}); }catch(e){ input.focus(); }
    input.value=' '; try{ input.setSelectionRange(1,1); }catch(e){}
  }

  function paint(){
    var wd=curWord(), inWord={};
    if(wd) wd.cells.forEach(function(p){ inWord[p[0]+','+p[1]]=1; });
    var els=gridEl.querySelectorAll('.mf-cell--l');
    for(var i=0;i<els.length;i++){
      var e=els[i], r=+e.getAttribute('data-r'), c=+e.getAttribute('data-c');
      e.firstChild.textContent=letters[r][c];
      e.classList.toggle('is-word', !!inWord[r+','+c]);
      e.classList.toggle('is-cur', !!cur && cur.r===r && cur.c===c);
      e.classList.toggle('is-hint', !!hints[r+','+c]);
      if(!letters[r][c]) e.classList.remove('is-bad');
    }
    var lis=listEl.querySelectorAll('li');
    for(i=0;i<lis.length;i++) lis[i].classList.toggle('is-on', wd && +lis[i].getAttribute('data-w')===G.words.indexOf(wd));
    clueEl.innerHTML = wd ? '<span class="mf-clue-n">'+wd.n+' '+ARROW[wd.d]+'</span> '+wd.q+' <em>('+wd.a.length+' lettres)</em>' : '';
    var done=isDone(); doneEl.classList.toggle('on',done);
  }

  function isDone(){
    for(var r=0;r<G.h;r++) for(var c=0;c<G.w;c++){ var cell=G.cells[r][c]; if(cell.t==='L' && letters[r][c]!==cell.ans) return false; }
    return true;
  }

  function step(delta){
    var wd=curWord(); if(!wd) return false;
    for(var k=0;k<wd.cells.length;k++) if(wd.cells[k][0]===cur.r && wd.cells[k][1]===cur.c) break;
    var n=k+delta; if(n<0||n>=wd.cells.length) return false;
    cur={r:wd.cells[n][0], c:wd.cells[n][1], d:cur.d}; return true;
  }

  function typeLetter(ch){
    if(!cur) return;
    letters[cur.r][cur.c]=ch;
    var e=cellEl(cur.r,cur.c); if(e) e.classList.remove('is-bad');
    step(1); save(); paint(); focusInput();
    if(isDone()) statusEl.textContent='';
  }
  function backspace(){
    if(!cur) return;
    if(letters[cur.r][cur.c]) letters[cur.r][cur.c]='';
    else if(step(-1)) letters[cur.r][cur.c]='';
    save(); paint(); focusInput();
  }
  function move(dr,dc){
    if(!cur) return; var r=cur.r+dr, c=cur.c+dc;
    while(r>=0&&c>=0&&r<G.h&&c<G.w){ if(G.cells[r][c].t==='L'){ select(r,c,dc?'a':'d'); return; } r+=dr; c+=dc; }
  }

  input.addEventListener('input',function(){
    var v=input.value;
    if(v.length===0){ backspace(); return; }
    var s=norm(v);
    for(var i=0;i<s.length;i++) typeLetter(s[i]);
    input.value=' '; try{ input.setSelectionRange(1,1); }catch(e){}
  });
  input.addEventListener('keydown',function(e){
    var k=e.key;
    if(k==='ArrowLeft'){e.preventDefault();move(0,-1);} else if(k==='ArrowRight'){e.preventDefault();move(0,1);}
    else if(k==='ArrowUp'){e.preventDefault();move(-1,0);} else if(k==='ArrowDown'){e.preventDefault();move(1,0);}
    else if(k==='Backspace' && input.value===''){e.preventDefault();backspace();}
    else if(k==='Enter'){e.preventDefault(); input.blur();}
  });

  gridEl.addEventListener('click',function(e){
    var el=e.target.closest('.mf-cell'); if(!el||el.classList.contains('mf-cell--e')) return;
    var r=+el.getAttribute('data-r'), c=+el.getAttribute('data-c'), cell=G.cells[r][c];
    if(cell.t==='L'){
      if(cur && cur.r===r && cur.c===c && cell.w.a!==undefined && cell.w.d!==undefined) select(r,c,cur.d==='a'?'d':'a');
      else select(r,c, cur?cur.d:'a');
    } else {
      var list=cell.clues, j=0;
      if(lastClueTap && lastClueTap.r===r && lastClueTap.c===c) j=(lastClueTap.j+1)%list.length;
      lastClueTap={r:r,c:c,j:j};
      selectWord(G.words[list[j]]);
    }
  });
  function selectWord(wd){
    var p=wd.cells.filter(function(q){return !letters[q[0]][q[1]];})[0]||wd.cells[0];
    select(p[0],p[1],wd.d);
  }
  listEl.addEventListener('click',function(e){
    var li=e.target.closest('li[data-w]'); if(!li) return;
    selectWord(G.words[+li.getAttribute('data-w')]);
    var top=boardEl.getBoundingClientRect().top+window.pageYOffset-120;
    window.scrollTo({top:Math.max(0,top),behavior:'smooth'});
  });
  /* ordinateur : on recalcule la taille si la fenetre change */
  var gjMfResize; window.addEventListener('resize',function(){ clearTimeout(gjMfResize); gjMfResize=setTimeout(function(){ if(window.innerWidth>=900 && G){ var fitW=Math.floor((window.innerHeight-150)*G.w/G.h); boardEl.style.setProperty('max-width',Math.max(300,Math.min(520,fitW))+'px','important'); } },150); });
  app.querySelector('.mf-levels').addEventListener('click',function(e){
    var b=e.target.closest('[data-level]'); if(b) setLevel(b.getAttribute('data-level'));
  });
  app.querySelector('.mf-actions').addEventListener('click',function(e){
    var b=e.target.closest('[data-act]'); if(!b) return; var act=b.getAttribute('data-act');
    if(act==='check'){
      var bad=0, empty=0;
      for(var r=0;r<G.h;r++) for(var c=0;c<G.w;c++){ var cell=G.cells[r][c]; if(cell.t!=='L') continue;
        var e2=cellEl(r,c);
        if(!letters[r][c]){ empty++; continue; }
        var wrong=letters[r][c]!==cell.ans; if(wrong) bad++; e2.classList.toggle('is-bad',wrong); }
      statusEl.textContent = isDone() ? '' : bad ? (bad+' lettre'+(bad>1?'s':'')+' à corriger') : (empty ? 'Tout est juste pour l’instant, continuez !' : '');
    } else if(act==='hint'){
      var target=null, wd=curWord();
      var pick=function(cells){ for(var i=0;i<cells.length;i++){ var p=cells[i]; if(letters[p[0]][p[1]]!==G.cells[p[0]][p[1]].ans) return p; } return null; };
      if(wd) target=pick(wd.cells);
      if(!target) for(var i=0;i<G.words.length && !target;i++){ target=pick(G.words[i].cells); if(target) cur={r:target[0],c:target[1],d:G.words[i].d}; }
      if(target){ letters[target[0]][target[1]]=G.cells[target[0]][target[1]].ans; hints[target[0]+','+target[1]]=1;
        var e3=cellEl(target[0],target[1]); if(e3) e3.classList.remove('is-bad');
        cur={r:target[0],c:target[1],d:cur?cur.d:'a'}; if(G.cells[cur.r][cur.c].w[cur.d]===undefined) cur.d=cur.d==='a'?'d':'a';
        save(); paint(); statusEl.textContent=''; }
    } else if(act==='reset'){
      store(key(),null); setLevel(level);
    }
  });

  setLevel(level);
})();
